module.exports = __webpack_public_path__ + "static/media/very-good-v2.5367ee6f.svg";